module.exports = __webpack_public_path__ + "static/media/Kitchen & Appliances.3be172eb.webp";